// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","355":"1fd05948","455":"1b991356","977":"5d9c67ca"}[chunkId] + ".chunk.js";
};